import Link from 'next/link';
import { useRouter } from 'next/router';
import { FC } from 'react';

import { SponsorCardContent } from '@/components/event/SponsorCardContent';
import { useAnalytics } from '@/context/Analytics';
import { EventSponsor } from '@/resources/EventSponsor';

interface ISponsorCardProps {
  eventSponsor: EventSponsor;
}

export const SponsorCard: FC<ISponsorCardProps> = ({ eventSponsor }) => {
  const router = useRouter();
  const analytics = useAnalytics();
  const { id, slug, enabledFeatures, website } = eventSponsor;

  const hasAction = enabledFeatures.directLink || enabledFeatures.about || enabledFeatures.qa;

  const handleSponsorAction = () => {
    analytics.track('external_link_click', { link: website });
  };

  if (!hasAction) {
    return <SponsorCardContent eventSponsor={eventSponsor} />;
  }

  if (enabledFeatures.directLink) {
    return (
      <Link href={website} target="_blank" rel="noopener noreferrer" onClick={handleSponsorAction}>
        <SponsorCardContent eventSponsor={eventSponsor} />
      </Link>
    );
  }

  return (
    <Link href={`/events/${router.query.eventId}/expo/${id}-${slug}`}>
      <SponsorCardContent eventSponsor={eventSponsor} />
    </Link>
  );
};
